import { BrowserCacheLocation, PublicClientApplication } from '@azure/msal-browser';

import { ENV } from '@/config/env';

export const MSAL_SCOPES = ['openid', 'profile', ENV.VITE_MSAL_BACKEND_SCOPE];

export const pca = new PublicClientApplication({
	auth: {
		clientId: ENV.VITE_MSAL_CLIENT_ID,
		authority: ENV.VITE_MSAL_AUTHORITY_URL,
		redirectUri: window.location.origin,
		postLogoutRedirectUri: '/sign-in',
	},
	cache: {
		cacheLocation: BrowserCacheLocation.LocalStorage,
	},
});
